export interface HotelChainsFamily {
  organization?: string;
  partitionId?: string;
  name: string;
  id?: string;
  version?: number;
  description?: string;
  elements: HotelChainsElements;
}

export interface HotelChainsElements {
  chains?: string[];
}

export const initialHotelChainsFamily: HotelChainsFamily = {
  organization: '',
  name: '',
  description: '',
  elements: {}
};

export interface HotelChainsFamilySearchCriteria {
  organization?: string;
  partitionId?: string;
  name?: string;
  chains?: string[];
  enableFullTextSearch?: boolean;
}

export interface HotelPropertyCodesFamily {
  organization?: string;
  partitionId?: string;
  name: string;
  id?: string;
  version?: number;
  description?: string;
  elements: HotelPropertyCodesElements;
}

export interface HotelPropertyCodesElements {
  propertyCodes?: string[];
}

export const initialHotelPropertyCodesFamily: HotelPropertyCodesFamily = {
  organization: '',
  name: '',
  description: '',
  elements: {}
};

export interface HotelPropertyCodesFamilySearchCriteria {
  organization?: string;
  partitionId?: string;
  name?: string;
  propertyCodes?: string[];
  enableFullTextSearch?: boolean;
}

export interface Location {
  name: string;
  id?: string;
}
